// extracted by mini-css-extract-plugin
export default {"splitter":"SplitterVertical_splitter__CGS1+"};